import { Guid } from '@fitscovery/common/types';
import { EmailTemplate, MembershipSubscriptionWithPMSEmailTemplate, PMSEmailTemplate } from '../models';

export class CreatePMSEmailTemplate {
  static readonly type = '[PMSEmailTemplate] CreatePMSEmailTemplate';

  constructor(public pmsEmailTemplate: PMSEmailTemplate) { }
}

export class UpdatePMSEmailTemplate {
  static readonly type = '[PMSEmailTemplate] UpdatePMSEmailTemplate';

  constructor(public pmsEmailTemplate: PMSEmailTemplate) { }
}

export class DeletePMSEmailTemplate {
  static readonly type = '[PMSEmailTemplate] DeletePMSEmailTemplate';

  constructor(public partnerMembershipSubscriptionId: Guid) { }
}

export class GetPMSEmailTemplatesByPartnerId {
  static readonly type = '[PMSEmailTemplate] GetPMSEmailTemplatesByPartnerId';

  constructor(public partnerId: Guid) { }
}

export class GetPMSEmailTemplate {
  static readonly type = '[PMSEmailTemplate] GetPMSEMailTemplate';

  constructor(public partnerMembershipSubscriptionId: Guid) { }
}







export class CreateEmailTemplate {
    static readonly type = '[EmailTemplate] CreateEmailTemplate';
  
    constructor(public emailTemplate: EmailTemplate) { }
  }
  
  export class UpdateEmailTemplate {
    static readonly type = '[EmailTemplate] UpdateEmailTemplate';
  
    constructor(public emailTemplate: EmailTemplate) { }
  }
  
  export class DeleteEmailTemplate {
    static readonly type = '[EmailTemplate] DeleteEmailTemplate';
  
    constructor(public emailTemplateId: Guid, public partnerId: Guid) { }
  }
  
  export class GetEmailTemplatesByPartnerId {
    static readonly type = '[EmailTemplate] GetEmailTemplatesByPartnerId';
  
    constructor(public partnerId: Guid) { }
  }
  
  export class GetEmailTemplateById {
    static readonly type = '[EmailTemplate] GetEmailTemplateById';
  
    constructor(public emailTemplateId: Guid) { }
  }
  
  export class GetEmailTemplatesByIsDefaultAndPartnerId {
    static readonly type = '[EmailTemplate] GetEmailTemplatesByIsDefaultAndPartnerId';
  
    constructor(public partnerId: Guid) { }
  }


  export class CreateMembershipSubscriptionWithPMSEmailTemplate {
    static readonly type = '[Membership] CreateMembershipSubscriptionWithPMSEmailTemplate';
  
    constructor(public membershipSubscriptionWithPMSEmailTemplate: MembershipSubscriptionWithPMSEmailTemplate) { }
  }
  export class UpdateMembershipSubscriptionWithPMSEmailTemplate {
    static readonly type = '[Membership] UpdateMembershipSubscriptionWithPMSEmailTemplate';
  
    constructor(public membershipSubscriptionWithPMSEmailTemplate: MembershipSubscriptionWithPMSEmailTemplate) { }
  }


